import { FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import FormControl from "@mui/material/FormControl";
import React from "react";

const useStyles = makeStyles(theme => ({
    radioButton: {
        "&.Mui-checked": {
            color: theme.palette.primary.main
        },
    },
}));

export default function RadioButtons({value, label, onChange, options, row, disabled}){

    const classes = useStyles();

    return <FormControl component="fieldset">

            <FormLabel component="legend" sx={{
                    '&.Mui-focused' : {
                        color : "secondary.main",
                    }
                }}
            >{label}</FormLabel>
            <RadioGroup value={value} onChange={(event) => onChange(event.target.value)} row={row}>

                {options.map(option => <FormControlLabel value={option.value}
                                      control={<Radio className={classes.radioButton} disabled={disabled}/>}
                                      label={option.label}/>
                )}

        </RadioGroup>
    </FormControl>
}